import { defineGameCard, modifyIncomingDamage } from '../authoring/index.js';
export const IronhideCard = defineGameCard({
    id: 'ironhide',
    gameplay: {
        type: 'UNIT',
        cost: 2,
        baseStats: { attack: 2, health: 5 },
    },
    presentation: {
        name: 'Броненосец',
        description: 'Получает на 1 меньше урона от любого источника (минимум 0).',
        glyph: {
            colors: ['#10213A', '#435577', '#5F789C', '#354364', '#303A59'],
            rows: [
                '....................',
                '........1111........',
                '..11...123321...11..',
                '.13311.122221.11331.',
                '1333321.1111.1233331',
                '13332221222212223331',
                '13311121422512142331',
                '.11..122333332111221',
                '.1...1423333241..11.',
                '.11..1144444111..11.',
                '122..1111111111.1221',
                '1221....1111....1221',
                '.111..11544511..1111',
                '.....1451551551.....',
                '.11..1441111441..11.',
                '.....15511.1551.....',
                '.....11511.1511.....',
                '....11111...1111....',
                '...155551..155551...',
                '...111111..111111...',
            ],
        },
    },
    role: 'standalone_lab',
    abilities: [
        modifyIncomingDamage((_ctx, planned) => {
            return Math.max(0, planned.amount - 1);
        }),
    ],
});
//# sourceMappingURL=ironhide.js.map